import React, { useContext } from 'react'
import SvgBackIcon from 'assets/icons/Back'
import styled, { ThemeContext } from 'styled-components'
import Box from './Box'
import { LayoutProps, SpaceProps, TypographyProps } from 'styled-system'

export type BackLinkProps = SpaceProps & LayoutProps & TypographyProps & {
  onClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  label: string
  color?: string
}

const BackLink: React.FC<BackLinkProps> = (props: BackLinkProps) => {
  const { onClick, label, color, ...restProps } = props
  const theme = useContext(ThemeContext)

  return (
    <BackToContainer onClick={onClick} {...restProps}>
      <SvgBackIcon fill={color ?? theme.colors.white} />
      <BackToText color={color}>{label}</BackToText>
    </BackToContainer>
  )
}

const BackToContainer = styled(Box)`
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 20px;
  width: fit-content;
`

const BackToText = styled(Box)`
  color: ${({ theme, color }) => color ?? theme.colors.white};
  font-weight: bold;
  font-size: 16px;
  margin-left: 10px;
`

export default BackLink